[
    {
        "uuid": "9bfe8fe3-19b4-4126-a5cd-b19609e9702d",
        "region": ["UKIMEA", "Europe", "Australasia"],
        "discipline": ["electrical engineer"],
        "title": "Voltage drop",
        "subtitle": "Voltage drop of a cable with metric units",
        "image": "elec-wire.jpg",
        "description": "Voltage drop of a cable using the cable length in meters, the design current in amps, the number of parallel conductor sets, and the cable impedance per meter.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/411a5d73-2a0f-46e2-85f8-85cfcef6b1af"
        }
    },
    {
        "uuid": "9c4af068-6f16-40c4-9155-1ba32742aff1",
        "region": ["Americas"],
        "discipline": ["electrical engineer"],
        "title": "Motor current",
        "subtitle": "Full Load Current (FLC) of a motor",
        "image": "elec-motor.jpg",
        "description": "2020 NEC Table 430.248 and 430.250 lookup of Full-Load Current in Amperes, Single-Phase and Three-Phase AC Motors.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/ff89c6fa-3fb0-4fe7-9c9c-948e815edfd5"
        }
    },
    {
        "uuid": "2ceac506-47c8-4f9b-b515-f11b5c240165",
        "region": ["Americas"],
        "discipline": ["electrical engineer"],
        "title": "Transformer lookup",
        "subtitle": "Standard transformer schedule",
        "image": "elec-transformer.jpg",
        "description": "Americas East Region standard copper transformer overcurrent protection and wiring schedule.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/b69070f4-1f6a-45cf-acc1-985f9f66d224"
        }
    },
    {
        "uuid": "3c8d5736-71aa-457e-80dd-9f8a112ebe10",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Rectangular column check",
        "subtitle": "Rectangular column check (simplified)",
        "image": "struc-rect-column.png",
        "description": "Rectangular column calculation to Eurocode 2 including second order effects",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/08829263-51a9-4411-8f42-f1e96f6c49cd"
        },
        "additional_links": [
            {
                "title": "Excel & GH Templates",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2826"
            },
            {
                "title": "Jupyter Template",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/3110"
            },
            {
                "title": "Related Calculation",
                "tooltip": "Rectangular column check including inputs for y and z direction bracing and largest nominal maximum aggregate size",
                "link": "https://compute.arup.digital/persistentCalcs/79767dcd-152f-4b39-8e76-241b5e1ac2f8"
            }
        ]
    },
    {
        "uuid": "aec9cbde-976d-4101-bba4-376632d14bb1",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Circular column check",
        "subtitle": "Circular column check (simplified)",
        "image": "struc-circ-column.jpg",
        "description": "Circular column calculation to Eurocode 2 including second order effects",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/82cc85fd-55fd-4198-b54f-11df73fa1aed"
        },
        "additional_links": [
            {
                "title": "Excel & GH Templates",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2826"
            },
            {
                "title": "Related Calculation",
                "tooltip": "Circular column check including inputs for y and z direction bracing and largest nominal maximum aggregate size",
                "link": "https://compute.arup.digital/persistentCalcs/420824fc-7d02-4f56-8f8e-b95c92811f0d"
            }
        ]
    },
    {
        "uuid": "4f76272d-a2af-411c-a00d-ad92ffa9d3a0",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Rectangular beam check",
        "subtitle": "Rectangular beam check (simplified)",
        "image": "struc-rect-beam.jpg",
        "description": "Calculates beam utilisation to Eurocode 2 including second order effects",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/7592f2dd-99f1-47bd-99ef-ef643140b51a"
        },
        "additional_links": [
            {
                "title": "Related Calculation",
                "tooltip": "Rectangular beam check including inputs for largest nominal maximum aggregate",
                "link": "https://compute.arup.digital/persistentCalcs/1b7db6eb-44cd-4b0d-9943-f194fae7a6a8"
            }
        ]
    },
    {
        "uuid": "7511dc91-977c-4ee4-8d8e-fd839efda8a8",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Steel member check",
        "subtitle": "Steel member check",
        "image": "struc-steel-member.jpg",
        "description": "Performs strength checks and returns the utilisation for a steel member to Eurocode 3.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/764427d6-0cc8-4308-9205-f2b55ba5f6c8"
        },
        "additional_links": [
            {
                "title": "Excel & GH Templates",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2853"
            }
        ]
    },
    {
        "uuid": "c1ff40d4-f6c5-4b4f-ad48-a56a3aea5274",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Anchorage length check",
        "subtitle": "Anchorage length check",
        "image": "struc-rebar-anchorage.png",
        "description": "Calculates the anchorage length of reinforcement to Eurocode 2",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/e1bc9220-813f-4c0d-a6d6-36c2650249d7"
        },
        "additional_links": []
    },
    {
        "uuid": "8e79f65c-01dc-4d47-84a7-60b9c19246be",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Lap length check",
        "subtitle": "Lap length check",
        "image": "struc-lap-length.jpg",
        "description": "Calculates the lap length of reinforcement to Eurocode 2",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/f3a765e8-cdce-49a1-8182-ed9070a8afa6"
        },
        "additional_links": []
    },
    {
        "uuid": "3f2e9f3b-bbaf-4f1b-8020-a6f043209114",
        "region": ["UKIMEA"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Wind loading",
        "subtitle": "Wind loading calculation for UK building to BS EN 1991-1-4",
        "image": "struc-storm-2.jpg",
        "description": "Calculates all the wind loading values needed for most simple buildings in the UK including: Peak velocity pressure, Overall wind pressure for stability calculations, wall and roof pressures for local checks and element design.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/940b8114-2af2-4398-9dac-9b47c7109e51"
        },
        "additional_links": [
            {
                "title": "Excel Spreadsheet",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/1795"
            }
        ]
    },
    {
        "uuid": "3b4b4d5e-7615-4d6a-93b4-5968f042e03f",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Cast in plate checker",
        "subtitle": " Cast in plate checks following 2014 SGN 09",
        "image": "struc-cip.png",
        "description": "The calculation follows the newly updated 2014 SGN 09, which is based upon a Eurocode approach. It is recommended to use the excel interface that can be found on the Tools Register.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/855eae58-3d92-4e4e-8f6a-d13b786499f8"
        },
        "additional_links": [
            {
                "title": "Excel Interface",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2923"
            },
            {
                "title": "2014 SGN 09",
                "link": "https://arup.sharepoint.com/:b:/r/sites/Structural/SiteCollectionDocuments/Insight%20-%20SGNs/2014%20SGN%2009%20Cast-in%20plates%20good%20practice%20guide.pdf?csf=1&web=1&e=fTq0gd"
            }
        ]
    },
    {
        "uuid": "ef19d79f-9480-4164-a7b5-2d5bc0cc188d",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["structural engineer", "BCS engineer"],
        "title": "Pilecap checker",
        "subtitle": "2, 3, 4 and 5 pile pilecaps",
        "image": "struc-pilecap.png",
        "description": "For checking the design of three, four and five-pile pile caps to BS EN 1992-1-1. For each, a generic calculation to Eurocode 2 has been created as well as a calculation specific to the UK NA. Strut & tie theory is used as the method of calculation within the DesignCheck functions and the calculations determine the utilisation values of the reinforcement, struts and nodes within the pile caps.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/d7d6ccc5-e22e-42ff-a385-4bc06a5d96eb"
        },
        "additional_links": [
            {
                "title": "EC2 Calcs",
                "link": "https://compute.arup.digital/library/14?path=v210.4.6-structural-ec-calcs-concrete-pilecap"
            },
            {
                "title": "UK NA Calcs",
                "link": "https://compute.arup.digital/library/14?path=v210.4.6-structural-ec-calcs-concrete-pilecap-na_uk"
            },
            {
                "title": "Excel Template",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2471"
            }
        ]
    },
    {
        "uuid": "6c7a0b77-42a4-4a1c-a369-4cee9f23185a",
        "region": ["UKIMEA", "Europe", "Americas", "Australasia"],
        "discipline": ["mechanical engineer"],
        "title": "Air properties ASHRAE",
        "subtitle": "Air properties based on ASHRAE Fundamentals 2017",
        "image": "mech-air-props.jpg",
        "description": "Returns properties of humid air (wet bulb temperature, enthalpy etc) using ASHRAE formulae",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/6c89d085-5b82-460f-af0a-3c054761d8cf"
        },
        "additional_links": []
    },
    {
        "uuid": "ba41c159-8e8b-4727-bd16-4b7980aa929c",
        "region": ["UKIMEA", "Europe", "Americas", "East Asia", "Australasia"],
        "discipline": ["mechanical engineer"],
        "title": "Duct pressure drop",
        "subtitle": "Duct pressure drop calculations with template spreadsheet for use",
        "image": "mech-duct-velocity.jpg",
        "description": "Functions for calculating pressure drops in ducts. As well as straight ducts, elbows, tees, transitions, louvres etc can be entered. The DesignCheck routines are based on CIBSE pressure drop calcs, while the information on pressure drops through fittings comes from the ASHRAE database since this is much more complete. The spreadsheet found on the Tools Register does not contain complex elements and can easily be modified to suit particular projects.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/5f7e5a84-c5ab-47c4-8e0e-2f6222481e15"
        },
        "additional_links": [
            {
                "title": "Tools Register",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2648"
            }
        ]
    },
    {
        "uuid": "98e33f7c-1935-4e8f-9afe-aad21f6b1ede",
        "region": ["UKIMEA", "Europe", "Americas", "East Asia", "Australasia"],
        "discipline": ["mechanical engineer"],
        "title": "Psychrometrics",
        "subtitle": "Psychrometric calculations with template spreadsheet for use",
        "image": "mech-psych.jpg",
        "description": "Functions for psychrometric calculations for AHUs etc. Demonstrates use of the TRH functions (which have inputs of Temp and RH) and the other functions which use AirState variables. Also shows how to create a psychrometric chart. The template spreadsheet linked on the Tools Register example is a cooling coil followed by a reheat coil, but the spreadsheet can be adapted to suit any particular AHU or research idea. The spreadsheet does not contain complex elements and can easily be modified to suit particular projects.",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/6f9568c8-7302-44b6-8b5e-425a48409784"
        },
        "additional_links": [
            {
                "title": "Tools Register",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/2652"
            }
        ]
    },
    {
        "uuid": "4fa60af5-39d7-427f-8071-563f665a99e4",
        "region": ["UKIMEA", "Europe", "Americas", "Australasia"],
        "discipline": ["mechanical engineer"],
        "title": "Duct velocity",
        "subtitle": "Duct velocity",
        "image": "mech-duct-velocity.jpg",
        "description": "Returns the average velocity of air in a duct",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/0acc808f-f03e-4456-b7cd-6d2900d61b3a"
        },
        "additional_links": []
    },
    {
        "uuid": "3a9d9297-3039-43a5-813b-90e778ffdec0",
        "region": ["Americas"],
        "discipline": ["plumbing engineer"],
        "title": "Fixture unit count cold water",
        "subtitle": "(OBC) Direct flush systems, public buildings",
        "image": "phhp-cold-water.jpg",
        "description": "Based on OBC 2012 Table 7.6.3.2.A returns the public cold water fixture unit count for direct flush systems",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/811f2fda-d266-45fe-a3d7-c6fb550f4736"
        },
        "additional_links": [
            {
                "title": "Tools Register",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/3150"
            }
        ]
    },
    {
        "uuid": "135c1d68-9c6a-4519-94d9-16e963c8bf07",
        "region": ["Americas"],
        "discipline": ["plumbing engineer"],
        "title": "Fixture unit count hot water",
        "subtitle": "(OBC) Public buildings",
        "image": "phhp-hot-water.jpg",
        "description": "Based on OBC 2012 Table 7.6.3.2.A returns the public hot water fixture unit count",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/dbe4be84-b3ad-4d15-94f8-5b64fd45a801"
        },
        "additional_links": [
            {
                "title": "Tools Register",
                "link": "https://arup.sharepoint.com/sites/tools-register/SitePages/ToolsRegister.aspx#/tool-details/3150"
            }
        ]
    },
    {
        "uuid": "82b2d09b-f37d-4729-8979-357b7395a16d",
        "region": ["UKIMEA", "Europe"],
        "discipline": ["plumbing engineer"],
        "title": "Appliance loading units",
        "subtitle": "(IOP/CIPHE) loading units",
        "image": "phhp-fixture.jpg",
        "description": "Returns IOP/CIPHE hot and cold water loading units and drainage discharge units",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/87d4386d-791b-4472-b04e-0a69a3c08f2b"
        },
        "additional_links": []
    },
    {
        "uuid": "8e879173-0976-4a3d-a403-30e216bc800f",
        "region": ["Americas"],
        "discipline": ["plumbing engineer"],
        "title": "Fixture units cold water count",
        "subtitle": "(IPC)",
        "image": "phhp-fixture.jpg",
        "description": "IPC TABLE E103.3(2) load values assigned to fixtures",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/e2dcf6b7-3c95-4d74-af8f-7cab3fde7ba0"
        },
        "additional_links": []
    },
    {
        "uuid": "e9e14d85-58a8-4ea8-8703-32d773831213",
        "region": ["Americas"],
        "discipline": ["plumbing engineer"],
        "title": "Fixture units hot water count",
        "subtitle": "(IPC)",
        "image": "phhp-hot-water.jpg",
        "description": "IPC TABLE E103.3(2) load values assigned to fixtures",
        "mainLink": {
            "title": "Go to calc",
            "link": "/persistentCalcs/2cd9400d-a28e-437b-ae01-d02d454faa41"
        },
        "additional_links": []
    }
]
